import {Sprite, Text} from 'pixi.js';
import {TextFactory} from '../../../../../../factories/TextFactory';
import {Pivot} from '../../../../../../utils/Pivot';

export class NameHolder extends Sprite
{
    valueText: Text;

    constructor() {
        super();

        this.valueText = TextFactory.create('', 30, 0xffffff);
        this.addChild(this.valueText);
    }

    set value(val: string) {
        this.valueText.text = val;
        Pivot.centerPivot(this.valueText, false);
    }

}
